import { createClient } from "@/apollo/clientUtils";
import { createHttpLink } from "apollo-link-http";

const dataSourceLink = createHttpLink({
  /*ToDo temporär auf persis umgebaut bis es ein recruiting scs gibt */
  uri: "/persis/private/data/recruiting"
});

export const recruiting = createClient(dataSourceLink);
